// import RNFS, { read } from 'react-native-fs';
export const saveImageToTempDir = async (mediaUri: string) => {
  // const base64Image = await getImageInBase64(mediaUri);
  // const path = `${RNFS.TemporaryDirectoryPath}/temp_image.png`;
  // await RNFS.writeFile(path, base64Image, 'base64');
  // return path;
  return '';
};
